import React, { useContext, useEffect } from "react"
import Fruchtgummi from "../components/Fruchtgummi"
import ContactForm from "../form/ContactForm"
import FiveFourTileWin from "../components/FiveFourTileWin"
import { Context } from "../store/store"
import Alert from "../components/elements/Alert"
import { updateIframeHeight, updateIframeScrollTo } from "../helper"

const Win: React.FC = () => {
	const { globalState } = useContext(Context)

	useEffect(() => {
		updateIframeScrollTo(0)
		window.scrollTo({
			top: 0,
			left: 0,
			behavior: "smooth",
		})

		updateIframeHeight()
		// eslint-disable-next-line
	}, [])

	return (
		<>
			<FiveFourTileWin />

			{/* Layout testing */}
			{/* <FiveFourTileWin debugDay={1} />
			<FiveFourTileWin debugDay={2} />
			<FiveFourTileWin debugDay={3} />
			<FiveFourTileWin debugDay={4} />
			<FiveFourTileWin debugDay={5} />
			<FiveFourTileWin debugDay={6} />
			<FiveFourTileWin debugDay={0} /> */}

			<div className="contentGradient">
				<div className="container text-center  py-12">
					{!globalState.raffledPrizeCode ? (
						<Alert>
							Hier ist etwas schief gelaufen...
							<br />
							Die aufgerufene Seite konnten wir leider nicht finden.
						</Alert>
					) : (
						<h1 className="h1">Herzlichen Glückwunsch</h1>
					)}

					<p className="pb-6">Damit wir dir deinen Gewinn zusenden können, verrate uns bitte deine persönlichen Daten:</p>

					<ContactForm />
					<a href="https://www.nimm2.de/de/ideen-inspirationen" target="_parent" rel="noopener noreferrer">
						<button className="btn text-[18px] lg:text-[30px]">Entdecke Basteltipps und vieles mehr</button>
					</a>
				</div>
				<Fruchtgummi />
			</div>
		</>
	)
}
export default Win
